import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Link = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
